<div class="pop-up-backdrop-ssn">


    <div class="ssn-security-wrap">
    
        <div class="close-ssn" (click)="closeSecurity()"><img src= "../../../../../assets/images/close.svg')" alt="" loading="lazy"></div>
        <div class="head">Your security is our priority.</div>
        <div class="logo"><img src="../../../../../assets/images/sign.svg'" alt="" loading="lazy"></div>
        <div class="desc">
            Your data is secured across the app using <br />2048-bit encryption keys and 256-bit advanced  <br />encryption algorithms.
        </div>

        <div class="authorize" (click)="closeSecurity()"><span>Ok</span></div>
    </div>